/**
 * 必须输入数字+大写字母+小写字母，允许输入特殊符号 ~,./?=!@#^%&_- 
 */
export const regPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d~,./?=!@#^%&_-]{8,20}$/;
/**
 * 校验密码
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 * @returns
 */
export const validPassword = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入密码'))
  }
  // 密码必须包含 字母+数字
  // const regPassword = /^(?![0-9]+$)(?![a-zA-Z]+$)[a-zA-Z0-9]{8,20}$/;
  // 密码必须包含字母+数字+特殊字符
  // const regPassword = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*])[\da-zA-Z~!@#$%^&*]{8,20}$/;
  // 密码必须包含数字+字母，并且允许输入特殊字符
  // const regPassword = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d\W]{8,20}$/
  if (!regPassword.test(value)) {
    console.log('密码格式不正确==>', value);
    return callback(new Error('密码格式不正确'));
  }
  callback();
}